import { MenuItem, Select } from '@mui/material';
import { makeStyles } from '@mui/styles';
import * as Sentry from "@sentry/react";
import Acent from "components/Acent";
import { get } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSchoologyGradeCategory } from "store/schoologyauth/selectors";
import { useCurrentUser } from "store/users/selectors";
import "./bingo.css";
import { BINGO_SIZE, BINGO_TYPE, BINGO_TYPE_RESOURCE } from "./helper";
import MultiCheckboxDropdown from "./type/multiCheckBoxDropdown";

import {
  Button,
  Col,
  Row
} from "antd";
import {
  bingoImageUrl
} from "utils/config/reference";

import { useCollectionLoteria } from "utils/methods/firebaseBingo";
import SentryWrap from 'components/Sentry';

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiSelect-select": {
      backgroundColor: "transparent", // Set background color to transparent
    },
  },
}));

const maxLength = 200;

const BingoCreateSection = ({
  handleConfigShare = () => null,
  gridValueSize,
  selectedBingoType,
  bingoInstruction,
  vocabData,
  selectedVocabData,
  setSelectedVocabData,
  bingoNotes,
  editLoteria,
  bingoConfig,
  gradeEnable,
  setGardeEnable,
  setGameGradeCategory,
  game_grade_category,
  game_grade_type,
  setGameGradeType,
  game_ungraded,
  setGameUngraded,
  onReset,
  from_where = '',
  draftId
}) => {
  const textareaRef1 = useRef(null);
  const textareaRefForNotes = useRef(null);
  const classes = useStyles();
  const lastSpinCountdownRef = useRef(null);
  const [configurations, setConfigurations] = useState({
    bingo_type: selectedBingoType || "",
    bingo_size: gridValueSize || 0
  });
  // for instruction:-
  const [inputValue, setInputValue] = useState("");
  const [wordCount, setWordCount] = useState(0);

  // for notes:-
  const [inputValueForNotes, setInputValueForNotes] = useState("");
  const [wordCountForNotes, setWordCountForNotes] = useState(0);

  const [lastSavedCriteria, setLastSavedCriteria] = useState("");
  const [lastSavedQuestion, setLastSavedQuestion] = useState("");
  const [lastSavedBingoType, setLastSavedBingoType] = useState("");
  const [lastSavedVocab, setLastSavedVocb] = useState([]);
  const [spinCountdownInput, setSpinCountdownInput] = useState("");
  const spinCountdownInputFocusedRef = useRef(false);
  const { createDraftBingo } = useCollectionLoteria();
  // debounce timer ref
  const saveTimeoutRef = useRef(null);

  
  const currentUser = useCurrentUser();
  const [, , schoologyAllClassGradeCategory] = useSchoologyGradeCategory();

  // Auto-save draft criteria after 4-5 seconds of inactivity
  useEffect(() => {
    if (get(currentUser, "role", "") === "owe_admin") {
      handleSaveDraft();
    }
  }, [inputValueForNotes, inputValue, selectedBingoType, draftId, lastSavedCriteria, lastSavedQuestion, lastSavedBingoType, configurations, selectedVocabData]);

  const handleSaveDraft = async () => {
    if (!draftId) return;

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
    }
    const grade = false
    saveTimeoutRef.current = setTimeout(async () => {
      const bingoType =
        configurations?.bingo_type === "VocabWord"
          ? "Word"
          : configurations?.bingo_type === "VocabImage"
          ? "Image"
          : configurations?.bingo_type === "OnlyImage"
          ? "OnlyImage"
          : configurations?.bingo_type;
      const configurationsData = {
        grade,
        grade_config: {},
        showStudent: false,
        selectedVocabData: selectedVocabData?.length > 0 ? selectedVocabData : [],
        bingo_type: bingoType,
        ...configurations,
      };
      
      if (
        inputValueForNotes !== lastSavedCriteria ||
        inputValue !== lastSavedQuestion ||
        bingoType !== lastSavedBingoType ||
        selectedVocabData !== lastSavedVocab
      ) {
        try {
          await createDraftBingo(draftId, {
            criteria: inputValueForNotes,
            question: inputValue,
            bingo_type: bingoType,
            configurations: configurationsData,
          });
          setLastSavedCriteria(inputValueForNotes);
          setLastSavedQuestion(inputValue);
          setLastSavedBingoType(bingoType);
          setLastSavedVocb(selectedVocabData);
        } catch (error) {
          console.error("Failed to save draft:", error);
        }
      }
    }, 3500);

    return () => {
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current);
      }
    };
  }

  const resetAllStates = () => {
    setConfigurations({
      bingo_type: "",
      bingo_size: 0
    });
    setInputValue("");
    setWordCount(0);
    setInputValueForNotes("");
    setWordCountForNotes(0);
    setSelectedVocabData([]);
  };

  useEffect(() => {
    if (onReset && !editLoteria?.id) {
      onReset(resetAllStates);
    }
  }, [onReset, editLoteria]);

  useEffect(() => {
    try {
      setConfigurations((prev) => ({
        bingo_type: selectedBingoType || "",
        bingo_size: gridValueSize || 0,
      }));

      const trimmedValue = bingoInstruction.slice(0, maxLength);
      setInputValue(trimmedValue);
      setWordCount(trimmedValue?.length);

      const trimmedValueForNotes = bingoNotes.slice(0, maxLength);
      setInputValueForNotes(trimmedValueForNotes);
      setWordCountForNotes(trimmedValueForNotes?.length);
    } catch (error) {
      Sentry.captureException(`620 Error in setConfigurations: ${error}`);
      console.log(error);
    }
  }, [selectedBingoType, gridValueSize, bingoInstruction, bingoNotes]);

  const handleInputFields = (key, value) => {
    setConfigurations((prev) => {
      const updated = {
        ...prev,
        [key]: value,
      };
      return updated;
    });
  };

  const handleWordLimit = (text) => {
    const trimmedValue = text.slice(0, maxLength);
    setInputValue(trimmedValue);
    setWordCount(trimmedValue.length);
  };

  const handleWordLimitForNotes = (text) => {
    setInputValueForNotes(text);
    setWordCountForNotes(text.length);
  };

  const handleWordForNotes = (text) => {
    setInputValueForNotes(text);
    setWordCountForNotes(text.length);
  };

  const handleSelectionChange = (data) => {
    setSelectedVocabData(data);
  };
  const checkValidNextButton = useMemo(() => {
    try {
      const hasRequiredConfigs =
        configurations?.bingo_type !== "" && configurations?.bingo_size !== 0;

      if (!hasRequiredConfigs) {
        return true;
      }

      const hasInstructions = inputValue.trim() !== "";
      if (
        configurations.bingo_type === "VocabImage" ||
        configurations.bingo_type === "VocabWord"
      ) {
        const isValidVocabData =
          Array.isArray(selectedVocabData) && selectedVocabData.length > 0;
        return !isValidVocabData || !hasInstructions; // Return true if either condition fails
      }

      return !hasInstructions;
    } catch (error) {
      Sentry.captureException(`621 Error in checkValidNextButton: ${error}`);
      console.error("Validation error:", error);
      return true; // Disable next button in case of an error
    }
  }, [configurations, selectedVocabData, inputValue]);

  return (
    <SentryWrap>
      <div className="ideaMdlUpr">
      <Row>
        <Col xs={24}>
          <div className="mainDbteValeSec">
            <div className="debateMdlTop">
              <img className="bingo-logo" src={bingoImageUrl} alt="Debate" />
            </div>
          </div>
        </Col>
        <Col xs={24}>
          <div className="liveDebateMdlLbl" style={{ position: "relative" }}>
            <Acent
              inputRef={textareaRefForNotes}
              setValue={handleWordForNotes}
              style={{
                marginBottom: 5,
                display: "flex",
                justifyContent: "flex-end",
              }}
              isDisabled={wordCountForNotes === 100}
            />
            <div className='wordCountAddonUpr'>
            <input
              className="title-input-field"
              ref={textareaRefForNotes}
              placeholder="Enter the title for your lotería here."
              value={inputValueForNotes}
              maxLength={100}
              onChange={(e) => {
                handleWordLimitForNotes(e.target.value);
              }}
            />
            <div className="wordCountDebate wordCountDebateAddon">
              <span>{`${wordCountForNotes}/100`}</span>
            </div>
            </div>
          </div>

          <div className="liveDebateMdlLbl" style={{ position: "relative" }}>
            <Acent
              inputRef={textareaRef1}
              setValue={handleWordLimit}
              style={{
                marginBottom: 5,
                display: "flex",
                justifyContent: "flex-end",
              }}
              isDisabled={wordCount === 200}
            />
            <div className='wordCountAddonUpr'>
            <textarea
              className="instruction-textarea"
              ref={textareaRef1}
              placeholder="Type instructions for your lotería here. (Students will see them on their lotería card.)"
              value={inputValue}
              onChange={(e) => {
                handleWordLimit(e.target.value);
              }}
            />
            <div className="wordCountDebate wordCountDebateAddon">
              <span>{`${wordCount}/200`}</span>
            </div>
            </div>
          </div>

          <Row className="gap-10px bingoSection bingo-select-field">
            <div className="midLiveDebateSec flex-1">
              <span>Select a type for Lotería</span>
              <div className="blogInputBox">
                <div className='blogInputBoxCstm'>
                  <Select
                    className={classes.root}
                    disableUnderline={true}
                    style={{ width: "100%" }}
                    required={true}
                    inputProps={{ "aria-label": "Without label" }}
                    onChange={(v) => {
                      const type = v.target.value;
                      setSelectedVocabData([]);
                      handleInputFields("bingo_type", type);
                    }}
                    value={configurations?.bingo_type}
                    label="Type"
                    // disabled={editLoteria?.id}
                  >
                    {BINGO_TYPE?.map((obj, index) => (
                          <MenuItem key={index + 1} value={obj?.value}>
                            {obj?.label}
                          </MenuItem>
                        ))}
                  </Select>
                </div>
              </div>
            </div>
            <div className="midLiveDebateSec flex-1">
              <span>Select a Lotería size</span>
              <div className="blogInputBox">
                <div className='blogInputBoxCstm'>
                  <Select
                    className={classes.root}
                    disableUnderline={true}
                    style={{ width: "100%" }}
                    required={true}
                    inputProps={{ "aria-label": "Without label" }}
                    onChange={(v) => {
                      const size = v.target.value;
                      handleInputFields("bingo_size", size);
                    }}
                    label="Type"
                    value={configurations?.bingo_size}
                    // disabled={editLoteria?.id}
                  >
                    {BINGO_SIZE?.map((obj, index) => (
                      <MenuItem key={index + 1} value={obj?.value}>
                        {obj?.label}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </div>
            </div>
          </Row>
          {(configurations?.bingo_type === "VocabImage" ||
            configurations?.bingo_type === "VocabWord") && (
            <div className="mt-10px midLiveDebateSec sm-flex-col sm-gap-10px">
              <span style={{ marginRight: "10px" }}>
                Select vocabulary for Lotería
              </span>
              <MultiCheckboxDropdown
                data={vocabData}
                onChange={handleSelectionChange}
                selectedVocabData={selectedVocabData}
              />
            </div>
          )}
        </Col>
        <Col xs={24}>
          <div className="debeteCountTypeSec debeteCountTypeSpace">
            <div className="debatCountTxt">
            </div>
            <div className="custoMshareBtn">
              <Button
                style={{ display: "flex", alignItems: "center" }}
                type="primary"
                className="shareBtnSec flex items-center"
                onClick={() => {
                  if (get(currentUser, "role", "") === "owe_admin") {
                    handleSaveDraft();
                  }
                  handleConfigShare(
                    configurations,
                    inputValue,
                    inputValueForNotes,
                    gradeEnable,
                    {
                      grade_category: game_grade_category,
                      grade_type: game_grade_type,
                      ungraded: game_ungraded,
                    }
                  );
                }}
                disabled={checkValidNextButton}
              >
                Next
              </Button>
            </div>
          </div>
        </Col>
      </Row>
      </div>
    </SentryWrap>
  );
};
export default BingoCreateSection;